import React from "react";
import SEO from '../../../services/SEO';
import YoutubeEmbed from "../../../components/YoutubeEmbed";
import { Link } from "react-router-dom";
import Translator from "../../../components/Translator";
import { Divider, List, Typography } from 'antd';
import { useTranslation } from "react-i18next";


const Dev = () => {

	window.scrollTo(0, 0);
	const { t, i18n: {changeLanguage, language} } = useTranslation();
	
	const data = [
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/ia/tls_text_speech'}><Translator path={'tls_text_speech'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/novos_conceitos/tls_screen'}><Translator path={'tls_screen'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/novos_conceitos/tls_factory'}><Translator path={'tls_factory'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/me/tls_etiquetas'}><Translator path={'tls_etiquetas'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/me/tls_testes'}><Translator path={'tls_testes'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/loterias/geracao_combinacoes'}><Translator path={'geracao_combinacoes'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/loterias/analise_combinacoes'}><Translator path={'analise_padroes'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/entretenimento/tls_overlay'}><Translator path={'tls_overlay'} /></Link>,
		<Link rel="noopener noreferrer" to={window.location.origin.toString() + '/entretenimento/tls_astronauta'}><Translator path={'tls_astronauta'} /></Link>
	];

	return(
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">{t('dev_info.desenvolvedor')}</h2>
			<br/>
			<hr/>
			<br/>
			
			<List
				size="large"
				header={<div>{t('dev_info.opcoes')}</div>}
				//footer={<div>Footer</div>}
				bordered
				dataSource={data}
				renderItem={(item: any) => <List.Item>{item}</List.Item>}
			/>
		</div>
	);
}


export default Dev;